// components/PublicProfile/utils/utils/PublicAvatarDisplay.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useProfilePicture } from "../../../../redux/user/profilePictures/useBulkProfilePictures";

const PublicAvatarDisplay = ({ userId, size = "w-8 h-8", className = "" }) => {
  const { t } = useTranslation();
  const { status, url } = useProfilePicture(userId);

  const defaultAvatar = "/avatars/aliens/alien_cool.svg";

  // Skeleton for loading state
  if (status === "loading") {
    return (
      <div
        className={`${size} rounded-full bg-gray-700/50 animate-pulse ${className}`}
      />
    );
  }

  return (
    <div
      className={`${size} rounded-full bg-gradient-to-br from-purple-500 to-blue-500 overflow-hidden ring-2 ring-gray-700/50 ${className}`}
    >
      <img
        src={url || defaultAvatar}
        alt={t('publicProfile.avatarAlt')}
        className="w-full h-full object-cover"
        onError={(e) => {
          if (e.currentTarget.src !== defaultAvatar) {
            e.currentTarget.src = defaultAvatar;
          }
        }}
        loading="lazy"
      />
    </div>
  );
};

export default PublicAvatarDisplay;
